import { type Connection } from '@blaze-shared/workflow-domain';

import { type CanvasElementId } from '../canvas-element/canvas-element-id';

// TODO: test
export function getInputWorkflowIdForElement(
  connections: Connection[],
  elementId: CanvasElementId,
): string | undefined {
  return connections.find(
    (conn) =>
      conn.target.layerType === 'Ui' &&
      conn.target.id === elementId &&
      conn.source.layerType === 'Workflow',
  )?.source.id;
}
